import * as constants from 'vd-constants';

export default class {
  constructor() {}

  getKeyPressed(event) {
    if (
      !Object.prototype.hasOwnProperty.call(event, 'key') &&
      !Object.prototype.hasOwnProperty.call(event, 'keyCode')
    ) {
      throw new Error('Invalid event type, expecting KeyboardEvent');
    }

    const self = this;
    let keyPressed = null;

    Object.keys(constants.KEYS).some((keyName) => {
      // If KeyboardEvent.key is not supported by the browser it will check KeyboardEvent.keyCode instead
      const key = constants.KEYS[keyName];
      if (
        self._checkKey(event, key.name, key.alternatives) ||
        self._checkKeyCode(event, key.value, key.shiftRequired)
      ) {
        keyPressed = key.name;
        return true;
      }
    });

    return keyPressed;
  }

  isNumber(event) {
    return (
      (event.key >= 0 && event.key <= 9) ||
      // Check for standard numbers
      (!event.shiftKey && event.keyCode >= 48 && event.keyCode <= 57) ||
      // Check for numpad numbers
      (event.keyCode >= 96 && event.keyCode <= 105)
    );
  }

  isKeyCombo(event, shiftKey, ctrlKey, altKey, metaKey) {
    return (
      (shiftKey && event.shiftKey) ||
      (ctrlKey && event.ctrlKey) ||
      (altKey && event.altKey) ||
      (metaKey && event.metaKey)
    );
  }

  _checkKeyCode(event, keyCode, shiftRequired = false) {
    // Check whether pressed key matches a key code value (see KeyboardEvent.keyCode)
    return (
      event.keyCode === keyCode &&
      ((!shiftRequired && !event.shiftKey) || (shiftRequired && event.shiftKey))
    );
  }

  _checkKey(event, key, alternatives = []) {
    // Check whether pressed key matches a key value (see KeyboardEvent.key).
    // Some earlier browser versions used different naming for key values, e.g. 'Up' instead of 'ArrowUp' and this is
    // handled via the alternatives
    return event.key === key || alternatives.indexOf(event.key) !== -1;
  }
}
